import { SMALL_SIZE, MEDIUM_SIZE, DEFAULT_SIZE, LARGE_SIZE, } from "../hooks/useUtilityStyles";
import { EXTRA_SMALL_BREAK, LARGE_BREAK, MEDUIM_BREAK, SMALL_BREAK, } from "./breakpoints.styles";
export const calculateDimension = (dimension) => {
    switch (dimension) {
        case "small":
            return SMALL_SIZE;
        case "medium":
            return MEDIUM_SIZE;
        case "default":
            return DEFAULT_SIZE;
        case "large":
            return LARGE_SIZE;
        case "zero":
            return 0;
        default:
            return {};
    }
};
export const calculateWidth = (width) => {
    if (width === undefined)
        return {};
    if (typeof width === "number" || typeof width === "string")
        return width;
    let calculatedWidth = {};
    if (width.extraSmall) {
        calculatedWidth = {
            ...calculatedWidth,
            [EXTRA_SMALL_BREAK]: {
                width: width.extraSmall,
            },
        };
    }
    if (width.small) {
        calculatedWidth = {
            ...calculatedWidth,
            [SMALL_BREAK]: {
                width: width.small,
            },
        };
    }
    if (width.medium) {
        calculatedWidth = {
            ...calculatedWidth,
            [MEDUIM_BREAK]: {
                width: width.medium,
            },
        };
    }
    if (width.large) {
        calculatedWidth = {
            ...calculatedWidth,
            [LARGE_BREAK]: {
                width: width.large,
            },
        };
    }
    return calculatedWidth;
};
